<template>
    <div class="ext" :class="{ 'ext--mobile': isMobile }">
      <div id="main" :style="chartBoxStyle"></div>
    </div>
</template>
<script>
export default {
  props: {
    /** 手机端：图例下移、取消扇区中心文字，避免与周围说明重叠 */
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      famlis: {
        token: null
      },
      ipos: {},
      pieData: []
    }
  },
  computed: {
    chartBoxStyle () {
      const h = this.isMobile ? '260px' : '240px'
      return { width: '100%', height: h }
    }
  },
  created () {
    this.famlis.token = this.$store.state.print.goodsForeNo.token
    this.bansData()
  },
  mounted () {
    this.drawLine()
    window.addEventListener('resize', this.onWinResize, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWinResize)
  },
  watch: {
    pieData: {
      handler () {
        this.drawLine()
      },
      deep: true
    },
    isMobile () {
      this.$nextTick(() => {
        this.drawLine()
      })
    }
  },
  methods: {
    onWinResize () {
      const el = document.getElementById('main')
      if (!el) return
      const chart = this.$echarts.getInstanceByDom(el)
      if (chart) chart.resize()
    },
    bansData () {
      this.$api.users.paymentProportion(this.famlis).then((res) => {
        console.log(res, '饼图')
        this.pieData = res.data.pie_data
        console.log(this.pieData, '饼图pieData')
      })
    },
    drawLine () {
      this.$nextTick(() => {
        const el = document.getElementById('main')
        if (!el) return
        let chart = this.$echarts.getInstanceByDom(el)
        if (!chart) {
          chart = this.$echarts.init(el)
        }
        const m = this.isMobile
        chart.setOption({
          tooltip: {
            trigger: 'item'
          },
          legend: m
            ? {
              bottom: 4,
              left: 'center',
              itemWidth: 10,
              itemHeight: 8,
              itemGap: 6,
              textStyle: { fontSize: 10, color: '#4A5372' }
            }
            : {
              top: '0%',
              left: 'center'
            },
          color: ['#5470c6', '#91cc75', '#fac858', '#ea7ccc', '#73c0de', '#3ba272', '#fc8452', '#9a60b4'],
          series: [
            {
              name: '本月',
              type: 'pie',
              radius: m ? ['30%', '52%'] : ['40%', '80%'],
              avoidLabelOverlap: true,
              itemStyle: {
                borderRadius: m ? 6 : 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: m
                ? {
                  show: false
                }
                : {
                  show: true,
                  position: 'center'
                },
              emphasis: {
                label: {
                  show: true,
                  fontSize: m ? 12 : 15,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              center: m ? ['50%', '46%'] : ['50%', '55%'],
              data: this.pieData
            }
          ]
        }, true)
        chart.resize()
      })
    }
  }
}
</script>
<style scoped>
.ext{
  width: 100%;
  height: 240px;
}
.ext--mobile{
  height: 260px;
}
</style>
